import React                                     from 'react';
import { WithStyle, withStyles }                 from 'rewire-ui';
import { Theme }                                 from '@material-ui/core/styles';
import DailyRollupView                           from '../../timecard/DailyRollupView';
import timecardTestEditTimecardsDailyRollupModel from './TimecardTestEditTimecardsDailyRollupModel';

const styles = (_theme: Theme) => ({
});

interface ITimecardTestEditTimecardsDailyRollupProps {
}

type TimecardTestEditTimecardsDailyRollupProps = WithStyle<ReturnType<typeof styles>, ITimecardTestEditTimecardsDailyRollupProps>;

class TimecardTestEditTimecardsDailyRollupView extends React.PureComponent<TimecardTestEditTimecardsDailyRollupProps> {
  constructor(props: TimecardTestEditTimecardsDailyRollupProps) {
    super(props);
  }

  render() {
    return (
      <DailyRollupView model={timecardTestEditTimecardsDailyRollupModel} />
    );
  }
}

export default withStyles<ITimecardTestEditTimecardsDailyRollupProps, unknown>(styles, TimecardTestEditTimecardsDailyRollupView);
